<script lang="ts">
import { Component, computed, defineAsyncComponent, defineComponent } from 'vue';
const UNKNOWN = defineAsyncComponent(() => import('@/shared/assets/currency/UNKNOWN.vue'));
const AED = defineAsyncComponent(() => import('@/shared/assets/currency/AED.vue'));
const AUD = defineAsyncComponent(() => import('@/shared/assets/currency/AUD.vue'));
const AZN = defineAsyncComponent(() => import('@/shared/assets/currency/AZN.vue'));
const BYN = defineAsyncComponent(() => import('@/shared/assets/currency/BYN.vue'));
const CAD = defineAsyncComponent(() => import('@/shared/assets/currency/CAD.vue'));
const CHF = defineAsyncComponent(() => import('@/shared/assets/currency/CHF.vue'));
const CNY = defineAsyncComponent(() => import('@/shared/assets/currency/CNY.vue'));
const CZK = defineAsyncComponent(() => import('@/shared/assets/currency/CZK.vue'));
const DKK = defineAsyncComponent(() => import('@/shared/assets/currency/DKK.vue'));
const EUR = defineAsyncComponent(() => import('@/shared/assets/currency/EUR.vue'));
const GBP = defineAsyncComponent(() => import('@/shared/assets/currency/GBP.vue'));
const GEL = defineAsyncComponent(() => import('@/shared/assets/currency/GEL.vue'));
const HKD = defineAsyncComponent(() => import('@/shared/assets/currency/HKD.vue'));
const JPY = defineAsyncComponent(() => import('@/shared/assets/currency/JPY.vue'));
const KGS = defineAsyncComponent(() => import('@/shared/assets/currency/KGS.vue'));
const KZT = defineAsyncComponent(() => import('@/shared/assets/currency/KZT.vue'));
const RUB = defineAsyncComponent(() => import('@/shared/assets/currency/RUB.vue'));
const SAR = defineAsyncComponent(() => import('@/shared/assets/currency/SAR.vue'));
const SEK = defineAsyncComponent(() => import('@/shared/assets/currency/SEK.vue'));
const SGD = defineAsyncComponent(() => import('@/shared/assets/currency/SGD.vue'));
const THB = defineAsyncComponent(() => import('@/shared/assets/currency/THB.vue'));
const TRY = defineAsyncComponent(() => import('@/shared/assets/currency/TRY.vue'));
const USD = defineAsyncComponent(() => import('@/shared/assets/currency/USD.vue'));
const XAU = defineAsyncComponent(() => import('@/shared/assets/currency/XAU.vue'));

export default defineComponent({
  name: 'UiEntityLogo',
  components: {
    AED,
    AUD,
    AZN,
    BYN,
    CAD,
    CHF,
    CNY,
    CZK,
    DKK,
    EUR,
    GBP,
    GEL,
    HKD,
    JPY,
    KGS,
    KZT,
    RUB,
    SAR,
    SEK,
    SGD,
    THB,
    TRY,
    USD,
    XAU,
    UNKNOWN,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      default: 'sm',
    },
  },
  setup(props) {
    const sizes: { [p: string]: number } = {
      md: 40,
      sm: 28,
      xs: 20,
    };
    const curLogos: { [p: string]: Component } = {
      AED,
      AUD,
      AZN,
      BYN,
      CAD,
      CHF,
      CNY,
      CZK,
      DKK,
      EUR,
      GBP,
      GEL,
      HKD,
      JPY,
      KGS,
      KZT,
      RUB,
      SAR,
      SEK,
      SGD,
      THB,
      TRY,
      USD,
      XAU,
      UNKNOWN,
    };

    const src = computed(() => {
      if (props.name && curLogos[props.name]) {
        return curLogos[props.name];
      }
      return curLogos.UNKNOWN;
    });
    const fontSize = computed(() => {
      return {
        'font-size': (props.size ? sizes[props.size] : sizes.md) + 'px',
      };
    });

    return { src, fontSize };
  },
});
</script>

<template>
  <div
    class="entity-logo"
    :style="fontSize"
    :class="{ 'entity-logo--small': size === 'sm', 'entity-logo--extra-small': size === 'xs' }"
  >
    <span><component :is="src" class="entity-logo" /></span>
  </div>
</template>

<style scoped lang="scss">
@import 'styles.module';
</style>
